module.exports = __webpack_public_path__ + "img/fitupCalculator.3038aefe.png";